import { FC } from 'react';

import { useNavigate } from 'react-router-dom';

import { usePageTitle } from 'hooks/usePageTitle';

import { Button } from 'components/parts/Button';
import Failure from 'images/icon/failure.svg';

import styles from './CardFailure.module.scss';

export const CardFailure: FC = () => {
  const navigate = useNavigate();

  usePageTitle(`クリアカード`);

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.body}>
          <img src={Failure} alt="" className={styles.Icon} />
          <p className={styles.message}>二次元コード読み取り失敗！</p>
          <p className={styles.text}>読み取った二次元コードが正しくないみたい...</p>
          <p className={styles.text}>お店の人に確認してみてね。</p>
        </div>
        <div className={styles.foot}>
          <Button
            text="カードリストに戻る"
            styleType="secondary"
            handleClick={() => navigate('/card')}
          />
        </div>
      </div>
    </div>
  );
};
